module.exports = __webpack_public_path__ + "media/images/newsletter/setouchi/hero-55bf312cb248eae68b39e6d212a14a40.jpg";